import { createElement, useCallback, useState, useEffect } from 'react';
import { ListDesign, ListItem } from '../';
import { isNullish } from '@sas/nova-core/typeguards';
import { RadioListProps } from './types';

/**
 * @deprecated
 * Please use List instead.
 */
export const RadioList = (props: RadioListProps) => {
  const [focusedIndex, setFocusedIndex] = useState<number | null | undefined>(undefined);
  const onSelected = useCallback(
    ({ index }: { index: number }): void => {
      props.onSelected(index);
      setFocusedIndex(index);
    },
    [props]
  );

  useEffect(() => setFocusedIndex(undefined), [props.items.length]);

  return (
    <ListDesign
      className={props.className}
      style={props.style}
      testId={props.testId}
      font={props.font}
      theme={props.theme}
      setFocusedIndex={setFocusedIndex}
      onSelectFocusedItem={() => {
        if (!isNullish(focusedIndex)) {
          props.onSelected(focusedIndex);
        }
      }}
      focusable={false}
      ariaLabel={props.ariaLabel}
    >
      {props.items.map((item, index) => (
        <ListItem
          {...item}
          selected={index === props.selectedIndex}
          focused={index === focusedIndex}
          focusable={index === (focusedIndex ?? 0)}
          onFocus={
            isNullish(focusedIndex) && index === 0
              ? () => {
                  setFocusedIndex(0);
                }
              : undefined
          }
          key={index}
          index={index}
          displayMode="radio"
          concatSecondaryText={props.concatSecondaryText}
          onSelected={onSelected}
        />
      ))}
    </ListDesign>
  );
};
